<div class="validation"
     *ngIf="!isValid">
  {{ validationState.message }}
</div>
